module.exports = __webpack_public_path__ + "img/200-south-africa.2fdc7d0e.svg";